module.exports = __webpack_public_path__ + "static/media/playboy-tv-6334372e.565647c7.jpg";